type GenericNotificationProps = {
  message: string;
};

const GenericNotification = ({ message }: GenericNotificationProps) => {
  return (
    <div className="mt-2 flex items-center gap-3 rounded-xl border border-line-subtle bg-surface-card shadow-lg px-4 py-3 text-sm text-ink-primary">
      {message}
    </div>
  );
};

export default GenericNotification;
